import { render, staticRenderFns } from "./mutilForm.vue?vue&type=template&id=0ba2f351"
import script from "./mutilForm.vue?vue&type=script&lang=js"
export * from "./mutilForm.vue?vue&type=script&lang=js"
import style0 from "./mutilForm.vue?vue&type=style&index=0&id=0ba2f351&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports